"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var form_1 = require("../form");
function CheckboxDirective(config) {
    'ngInject';
    return {
        templateUrl: config.params.base + 'templates/form/options/checkbox.html',
        controller: /** @class */ (function (_super) {
            __extends(CheckboxController, _super);
            function CheckboxController($scope, book) {
                'ngInject';
                var _this = _super.call(this, $scope, book) || this;
                var index = book.getIndex(_this.prefix, _this.id);
                _this.form.value = _this.form.getOptions()[index].case === 'true';
                $scope.$watch(function () { return book; }, function () { return _this.onChange(); }, true);
                if (_this.form.reset) {
                    $scope.$watch(function () { return _this.form.isDisabled(); }, function (value) {
                        if (value) {
                            _this.resetCheckbox();
                        }
                    }, true);
                    $scope.$watch(function () { return _this.form.isHidden(); }, function (value) {
                        if (value) {
                            _this.resetCheckbox();
                        }
                    }, true);
                }
                _this.onCheck(_this.form.value);
                return _this;
            }
            CheckboxController.prototype.onCheck = function (check) {
                this.form.value = check;
                var index = this.form.getOptions().findIndex(function (element) {
                    return (element.case === 'true') === check;
                });
                var valid = this.form.hasValidation('required') ? !!check : true;
                this.form.setValidity(this.form.validation, valid);
                this.book.update(this.prefix, this.id, index);
            };
            CheckboxController.prototype.onChange = function () {
                var value = this.book.get(this.prefix, this.id);
                var option = this.form.getOptions().find(function (element) {
                    return element.value === value;
                });
                var check = option.case === 'true';
                if (this.form.value !== check) {
                    this.onCheck(check);
                }
            };
            CheckboxController.prototype.resetCheckbox = function () {
                var defaultOption = this.form.getOptions()[this.form.default];
                var defaultValue = defaultOption.case === 'true';
                if (this.form.value !== defaultValue) {
                    this.onCheck(defaultValue);
                }
            };
            return CheckboxController;
        }(form_1.FormOptionController)),
        controllerAs: 'checkboxCtrl'
    };
}
exports.CheckboxDirective = CheckboxDirective;
